import {createApp} from 'vue';
import {createPinia} from 'pinia';
import AppBasket from '@/AppBasket.vue';
import AppStickyBasket from '@/AppStickyBasket.vue';
import AppOrderBlocks from '@/AppOrderBlocks.vue';
import {initSentry} from '../sentry-config';

const commonStore = createPinia();

const basketApp = createApp(AppBasket);
basketApp.use(commonStore);

const stickyBasketApp = createApp(AppStickyBasket);
stickyBasketApp.use(commonStore);

const orderBlocksApp = createApp(AppOrderBlocks);
orderBlocksApp.use(commonStore);

initSentry([basketApp, stickyBasketApp, orderBlocksApp]);

basketApp.mount('#app-basket');
stickyBasketApp.mount('#app-sticky-basket');
orderBlocksApp.mount('#app-order-blocks');
